import React, { forwardRef, memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Loader from 'legacy/common/components/layout/Loader';
import { FormProps, PrePurchaseQuestionsFormProps } from 'features/forms/types';
import useGetFormData from './hooks/useGetFormData';
import GlobalFormError from '../../Webview/components/GlobalFormError';
import Form from './components/Form';

import 'survey-core/survey-core.min.css';

const PrePurchaseQuestions = (
  {
    eventId,
    prePurchaseFormId,
    handleComplete,
    handleSetCanSubmit,
    handleInitError,
    isRenderedInWebview,
    handleInitSuccess
  }: PrePurchaseQuestionsFormProps & FormProps,
  ref: React.RefObject<{ submit: () => void; reset: () => void }>
) => {
  const { t } = useTranslation(['checkout']);
  const { form, response, isLoading, isError } = useGetFormData(
    eventId,
    prePurchaseFormId
  );

  useEffect(() => {
    if (isError && isRenderedInWebview) {
      handleInitError?.();
    } else if (!isLoading && form?.schema) {
      if (isRenderedInWebview) {
        handleInitSuccess?.(form.schema);
      }
    }
  }, [isError, isLoading, isRenderedInWebview]);

  if (isLoading) {
    return <Loader isOverlay isLoading={isLoading} />;
  }

  if (isError || !form || !form.schema) {
    return <GlobalFormError>{t('forms:initError')}</GlobalFormError>;
  }

  return (
    <Form
      ref={ref}
      form={form}
      response={response}
      isRenderedInWebview={isRenderedInWebview}
      handleComplete={handleComplete}
      handleSetCanSubmit={handleSetCanSubmit}
    />
  );
};

export default memo(forwardRef(PrePurchaseQuestions));
